import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    resetSubUserPasswordRequest,
    clearRedux
} from 'Redux/actions';

const ResetSubUserPassword = () => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const { openModal, loading, result, subuser } = useSelector(state => state.subUsersReserPasswordRedux);
    

    const closeModal = () => {
        dispatch(clearRedux("RESET_SUBUSER_PASSWORD"));
    }

    const applyChanges = () => {
        subuser && dispatch(resetSubUserPasswordRequest(subuser?.id))
    }

    useEffect(() => {
        if (result) {
            if (result?.reset) {
                NotificationManager.success(
                    messages['reset_subuser_auth_success_message'],
                    messages['reset_subuser_auth_title'],
                    3000,
                );
                closeModal();
            } else {
                NotificationManager.error(
                    messages['reset_subuser_auth_error_message'],
                    messages['reset_subuser_auth_title'],
                    3000,
                );
                dispatch(clearRedux("RESET_SUBUSER_PASSWORD", { result: null }));
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['reset_subuser_auth_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <p>{messages['reset_subuser_auth_message']}</p>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['reset_subuser_auth_label']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ResetSubUserPassword;